/* src/app/shared/zones/zones.component.scss */
.meter {
  width: 66%;
  box-sizing: content-box;
  height: 2vw;
  position: relative;
  margin-top: 1vw;
  margin-bottom: 1vw;
  border-radius: 3vw;
  background-color: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.1);
}
.meter > span {
  display: block;
  height: 100%;
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  position: relative;
  overflow: hidden;
}
.bottomLine {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
.zoneTitle {
  padding-left: 1vw;
  position: relative;
  bottom: -1vw;
}
.zoneZones {
  font-size: small;
  padding-left: 2vw;
}
/*# sourceMappingURL=zones.component.css.map */
